var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-loader"},[_c('md-progress-spinner',{staticClass:"md-success",attrs:{"md-stroke":10,"md-diameter":50,"md-mode":"indeterminate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }